import EditComponent from './EmailSupplierEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'emailSupplier';

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'supplierName'
        },
        {
            title: 'SMTP服务器地址',
            dataIndex: 'smtpHost'
        },
        {
            title: 'SMTP端口号',
            dataIndex: 'smtpPort'
        },
        {
            title: 'IMAP服务器地址',
            dataIndex: 'imapHost'
        },
        {
            title: 'IMAP端口号',
            dataIndex: 'imapPort'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '邮件供应商',
        apiId,
        columns,
        showStates: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponent;
